import { TYPE_REDUSER } from "../../utils/constants";

const initialState = {
    SaveModal: {
        open: false,
        data: null
    }
}

export const Modals = (state = initialState, action) => {
    switch (action.type) {
        case TYPE_REDUSER.CHANGE_MODAL_STATE: 
            const { modalName, data } = action.payload;
            return {
                ...state,
                [modalName]: {...state[modalName], open: !state[modalName].open, data}
            }
    
        default:
            return state;
    }
}